<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="row">
    <div class="col-md-4">
      <div><label for="email">Module</label></div>
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedMainmoduleValue" (closed)="mainModulesearchTxt=''"
        [disabled]="true" (click)="focusmethod('mainModulefocusSearch')"
        (keydown.enter)="focusmethod('mainModulefocusSearch')">
        <input type="search" id="mainModulefocusSearch" class="dropdownsearchstyle" [(ngModel)]="mainModulesearchTxt"
          matInput placeholder="Search">
        <mat-option class="unselectStyle" [value]="null"
          (onSelectionChange)="onMainModuleSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of moduleValueDropdown | assessmentSearch :mainModulesearchTxt"
          (onSelectionChange)="onMainModuleSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
  </div>
</div>
<div class="row">
  <div class="search-button-continer" mat-dialog-actions style="margin-bottom: 5px;">
    <button mat-stroked-button class="searchButton" style="margin-top: 10px;" (click)="getcallMethod()"
      (keydown.enter)="getcallMethod()">
      <i class="fa-solid fa-magnifying-glass"></i> Search
    </button>
  </div>
</div>
<div class="position-relative grid-content">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" (input)="globalFilter($event)" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (keydown.enter)="openAddPopup()" (click)="openAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="dynamic-table-container">
      <th style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>
        </div>
      </th>
      <th id="grid-header-container"
        *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width !=null ? oneQmsUsersDataForTable1Data.width :200,'max-width': oneQmsUsersDataForTable1Data.width !=null ? oneQmsUsersDataForTable1Data.width :200,'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" class="sticky-dynamic-col1">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
          <div class="d-flex gap-2 align-items-center">
            <div (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
              (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
              <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>

          </div>
        </div>
      </th>
      <th  class="sticky-col first-col"></th>
      <tr>
        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
          [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
          class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
          <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
        </td>
      </tr>
      <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
        <td style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
            </div>
          </div>
        </td>
        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
          class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width !=null ? key.width :200,'max-width': key.width !=null ? key.width :200,'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'}">
          <span *ngIf="list[key.columnsListarray]=='fileIspresentsa' || list[key.columnsListarray]=='fileIspresentsa'">
            <div class="download-button-continer" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="downloadTemplates(list,key.columnsListarray)">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img alt="access" *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img alt="noaccess" *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20">

            </div>
          </span>
          <span
            *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa'">{{
            list[key.columnsListarray] }}</span>
          <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
        </td>
        <td class="sticky-col first-col">
          <div class="action-icons">
            <i class="fa-solid fa-copy" matTooltip="Copy Document Type" style="margin-left: 5px;"
              (click)="copyPopupFunc(list)" (keydown.enter)="copyPopupFunc(list)"></i>
            <i class="fa-solid fa-pencil" matTooltip="Edit Document Type" style="margin-left: 5px;"
              (click)="editPopup(list)" (keydown.enter)="editPopup(list)"></i>
            <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;"
              (click)="deleteCodelistPopop(list)" (keydown.enter)="deleteCodelistPopop(list)"></i>
            <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
              src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list)"
              (keydown.enter)="openAuditTrail('individual',list)" />

          </div>
        </td>
      </tr>
    </table>

    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer" style="max-height: 542px !important;" *ngIf=" dynamicLabel">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email ">Module</label></div>
          <mat-select matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddModuleValue == selectedmoduleValue}" [(ngModel)]="selectedmoduleValue"
            (closed)="modulesearchTxt=''" (click)="focusmethod('modulefocusSearch')"
            (keydown.enter)="focusmethod('modulefocusSearch')" [disabled]=true>
            <input type="search" id="modulefocusSearch" class="dropdownsearchstyle" [(ngModel)]="modulesearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onModuleSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of moduleValueDropdown | assessmentSearch :modulesearchTxt"
              (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div><label for="email">{{dynamicLabel['DOCUMENT_TYPE_NAME']}}</label><span class="mandatory-symbol">*</span>
          </div>
          <input id="documentTypeName" class="input-filed-continers" type="text"
            [(ngModel)]="docTypeData.documentTypeName">
          <span id="documentTypeName-required-msg">Please enter the Document Type Name</span>
        </div>
        <div class="col-md-3">
          <div><label for="email">{{dynamicLabel['DOCUMENT_TYPE_CODE']}}</label><span class="mandatory-symbol">*</span>
          </div>
          <input id="documentTypeCode" class="input-filed-continers" type="text"
            [(ngModel)]="docTypeData.documentTypeCode" [disabled]="visibleEditButton"
            (keydown)="validateCodeFields($event)" (input)="sanitizeInput($event)">
          <span id="documentTypeCode-required-msg">Please enter the Document Type Code</span>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email ">{{dynamicLabel['LIST_OF_STAGES']}}</label></div>
          <mat-select matInput multiple placeholder="Select" #listofStages [(ngModel)]="selectDocTypeName"
            (closed)="listofStagesSearchText=''" (click)="focusSearch('listofStagesfocus')"
            (keydown.enter)="focusSearch('listofStagesfocus')">
            <input type="search" id="listofStagesfocus" class="dropdownsearchstyle" [(ngModel)]="listofStagesSearchText"
              matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isListofStagesSelected" (change)="toggleAllSelection('listofStages')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of docTypeValueDropdown | multiAssessmentSearchPipe :listofStagesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onDocTypeSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email ">{{dynamicLabel['CR_PROCESS']}}</label></div>
          <mat-select matInput placeholder="Select" [ngClass]="{'odd-item-mat-select': oddCRProcess == selectCRProcess}"
            [(ngModel)]="selectCRProcess" (closed)="crProcessSearchTxt=''" (click)="focusmethod('crProcessfocusSearch')"
            (keydown.enter)="focusmethod('crProcessfocusSearch')">
            <input type="search" id="crProcessfocusSearch" class="dropdownsearchstyle" [(ngModel)]="crProcessSearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onCrprocessSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of CRProcessValueDropdown| assessmentSearch :crProcessSearchTxt"
              (onSelectionChange)="onCrprocessSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['IS_ASSOCIATED_DOCUMENT_TYPE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.isAssociatedDocumentType">
            <span class="active-inActive-container" *ngIf="docTypeData.isAssociatedDocumentType"
              [ngStyle]="docTypeData.isAssociatedDocumentType==true?{'color':'green'} : {'color': ''}">Associated</span>
            <span *ngIf="docTypeData.isAssociatedDocumentType==false"
              [ngStyle]="docTypeData.isAssociatedDocumentType==false?{'color':'red'} : {'color': ''}">Not
              Associated</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" *ngIf="docTypeData.isAssociatedDocumentType==false && this.modulevalue=='DOCS'">
          <div><label for="email">{{dynamicLabel['POSSIBLE_ASSOCIATED_DOCUMENT_TYPES']}}</label></div>
          <mat-select matInput multiple placeholder="Select" #poAsdocumentTypes [(ngModel)]="selectedPossibleAssDoc"
            (closed)="poAsdocumentTypesSearchText=''" (keydown.enter)="focusSearch('poAsdocumentTypesfocus')"
            (click)="focusSearch('poAsdocumentTypesfocus')">
            <input type="search" id="poAsdocumentTypesfocus" class="dropdownsearchstyle"
              [(ngModel)]="poAsdocumentTypesSearchText" matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isPoAsdocumentTypesSelected"
                (change)="toggleAllSelection('poAsdocumentTypes')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of possibleAssDocDropdown | multiAssessmentSearchPipe :poAsdocumentTypesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onPossibleAssDocSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['BELONGS_TO_INDIVIDUAL']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.belongsToIndividual">
            <span class="active-inActive-container" *ngIf="docTypeData.belongsToIndividual"
              [ngStyle]="docTypeData.belongsToIndividual==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="docTypeData.belongsToIndividual==false"
              [ngStyle]="docTypeData.belongsToIndividual==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['FOOTER_MESSAGE_FORMAT']}}</label></div>
          <div><input id="footerMsg" class="input-filed-continers" type="text"
              [(ngModel)]="docTypeData.footerMessageFormat" style="width: 90%;">
            <i class="fas fa-exclamation-circle" (click)="clickToGetNote()" (keydown.enter)="clickToGetNote()"
              title="Reference Tags" style="cursor: pointer;color: green;"></i>
          </div>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['WATERMARK_MESSAGE_FORMAT']}}</label></div>
          <div><input id="waterMsg" class="input-filed-continers" type="text"
              [(ngModel)]="docTypeData.watermarkMessageFormat" style="width: 90%;">
            <i class="fas fa-exclamation-circle" (click)="clickToGetNote()" (keydown.enter)="clickToGetNote()"
              title="Reference Tags" style="cursor: pointer;color: green;"></i>
          </div>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['DOWNLOADED_DOCUMENT_NAME_FORMAT']}}</label></div>
          <div><input id="documentName" class="input-filed-continers" type="text"
              [(ngModel)]="docTypeData.downloadedDocumentNameFormat" style="width: 90%;">
            <i class="fas fa-exclamation-circle" (click)="clickToGetNote()" (keydown.enter)="clickToGetNote()"
              title="Reference Tags" style="cursor: pointer;color: green;"></i>
          </div>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['REMINDER_EXPIRY_BEFORE_N_DAYS']}}</label></div>
          <input id="firstName" class="input-filed-continers" type="number"
            [(ngModel)]="docTypeData.reminderExpiryBeforeNDays">
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['REMIND_EVERY_N_DAYS']}}</label></div>
          <input id="remindEveryNDays" class="input-filed-continers" type="number"
            [(ngModel)]="docTypeData.remindEveryNDays">
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['ASSIGNABLE_AT_TRAININGS']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.assignableAtTrainings">
            <span class="active-inActive-container" *ngIf="docTypeData.assignableAtTrainings"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.assignableAtTrainings" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['LIST_OF_FLEXIFIELD_NAMES']}}</label></div>
          <mat-select matInput multiple placeholder="Select" #listofFlexifields [(ngModel)]="selectFlexifieldsValue"
            (closed)="listofFlexifieldsSearchText=''" (click)="focusSearch('listofFlexifieldsfocus')"
            (keydown.enter)="focusSearch('listofFlexifieldsfocus')">
            <input type="search" id="podocumentTypesfocus" class="dropdownsearchstyle"
              [(ngModel)]="listofFlexifieldsSearchText" matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isListofFlexifieldsSelected"
                (change)="toggleAllSelection('listofFlexifields')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of flexifieldsValueDropdown | multiAssessmentSearchPipe :listofFlexifieldsSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onFlexifieldsSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div><label for="email">{{dynamicLabel['IS_ACTIVE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.isActive">
            <span class="active-inActive-container" *ngIf="docTypeData.isActive" style="color: green;">Active</span>
            <span *ngIf="!docTypeData.isActive" style="color: red;">InActive</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <div><label for="email">{{dynamicLabel['IS_AUTOPUBLISH']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.isAutopublish">
            <span class="active-inActive-container" *ngIf="docTypeData.isAutopublish" style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.isAutopublish" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" *ngIf="docTypeData.isAssociatedDocumentType==false">
          <div><label for="email">{{dynamicLabel['ASSOCIATED_DOC_TO_FOLLOW_SAME_EXPIRY']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.associatedDocToFollowSameExpiry">
            <span class="active-inActive-container" *ngIf="docTypeData.associatedDocToFollowSameExpiry"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.associatedDocToFollowSameExpiry" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <div><label for="email"
              *ngIf="docTypeData.isAssociatedDocumentType">{{dynamicLabel['IS_AMENDEMENT_DOC_TYPE']}}</label>
            <label for="email"
              *ngIf="docTypeData.isAssociatedDocumentType==false">{{dynamicLabel['IS_AMENDEMENT_ENABLED']}}</label>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.isAmendementDocType">
            <span class="active-inActive-container" *ngIf="docTypeData.isAmendementDocType"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.isAmendementDocType" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3"
          *ngIf="docTypeData.isAmendementDocType == true && docTypeData.isAssociatedDocumentType == false">
          <div><label for="email">{{dynamicLabel['ALLOWED_NO_OF_AMENDMENTS']}}</label></div>
          <input id="allowedNoOfExtentions" class="input-filed-continers" type="number"
            [(ngModel)]="docTypeData.allowedNoOfAmendments">

        </div>
        <div class="col-md-3">
          <!-- Extension Enabled ? -->
          <div><label for="email">{{dynamicLabel['EXTENTION_ENABLED']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.extentionEnabled">
            <span class="active-inActive-container" *ngIf="docTypeData.extentionEnabled"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.extentionEnabled" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" [hidden]="!docTypeData.extentionEnabled">
          <!-- Allowed No Of Extentions -->
          <div><label for="email">{{dynamicLabel['ALLOWED_NO_OF_EXTENTIONS']}}</label></div>
          <input id="allowedExtentions" class="input-filed-continers" type="number"
            [(ngModel)]="docTypeData.allowedNoOfExtentions">
        </div>
        <div class="col-md-3" [hidden]="!docTypeData.extentionEnabled">
          <!-- Extension List of Stages -->
          <div><label for="email">{{dynamicLabel['EXTENTION_LIST_OF_STAGES']}}</label></div>
          <mat-select matInput multiple placeholder="Select" #extnListOfStages
            [(ngModel)]="selectedExtensionListOfStages" (closed)="extnListOfStagesSearchText=''"
            (click)="focusSearch('extnListOfStagesSearchText')"
            (keydown.enter)="focusSearch('extnListOfStagesSearchText')">
            <input type="search" id="extnListOfStagesfocus" class="dropdownsearchstyle"
              [(ngModel)]="extnListOfStagesSearchText" matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isExtnListOfStagesSelected"
                (change)="toggleAllSelection('extnListOfStages')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of extensionListOfStagesDropdown | multiAssessmentSearchPipe :extnListOfStagesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onExtnListofStagesSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3"
          [ngStyle]="docTypeData.amendmentEnabled && docTypeData.extentionEnabled ? {'margin-top':'1%'}: {}">
          <!-- Withdraw List Of Stages -->
          <div><label for="email">{{dynamicLabel['WITHDRAWAL_LIST_OF_STAGES']}}</label></div>

          <mat-select matInput multiple placeholder="Select" #withdrawListOfStages
            [(ngModel)]="selectedObsoleteListOfStages" (closed)="withdrawListOfStagesSearchText=''"
            (click)="focusSearch('withdrawListOfStagesfocus')"
            (keydown.enter)="focusSearch('withdrawListOfStagesfocus')">
            <input type="search" id="withdrawListOfStagesfocus" class="dropdownsearchstyle"
              [(ngModel)]="withdrawListOfStagesSearchText" matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isWithdrawListOfStagesSelected"
                (change)="toggleAllSelection('withdrawListOfStages')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of obsoleteListOfStagesDropdown | multiAssessmentSearchPipe :withdrawListOfStagesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onWithdrawListOfStagesSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>


        <div class="col-md-3">
          <div><label for="email">{{dynamicLabel['DESTRUCTION_ENABLED']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.destructionEnabled">
            <span class="active-inActive-container" *ngIf="docTypeData.destructionEnabled"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.destructionEnabled" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3" [hidden]="!docTypeData.destructionEnabled">
          <div><label for="email"
              id="destructionListOfStatesfocus">{{dynamicLabel['DESTRUCTION_LIST_OF_STAGES']}}</label><span
              class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple placeholder="Select" #destructionListOfStates
            [(ngModel)]="selectedDestructionListOfStates" (closed)="destructionListOfStatesSearchText=''"
            (click)="focusSearch('destructionListOfStatesSearchText')"
            (keydown.enter)="focusSearch('destructionListOfStatesSearchText')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="destructionListOfStatesSearchText" matInput
              placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="destructionListOfStatesSelected"
                (change)="toggleAllSelection('destructionListOfStates')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of destructionListOfStatesDropdown | multiAssessmentSearchPipe :destructionListOfStatesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onDestructionListOfStatesSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>




        <div class="col-md-3" [ngStyle]="docTypeData.amendmentEnabled ? {'margin-top':'1%'}: {}">
          <!-- Document Type Code for ID Generation -->
          <div><label for="email">{{dynamicLabel['DOCUMENT_TYPE_CODE_FOR_ID_GENERATION']}}</label></div>
          <input id="Name" class="input-filed-continers" type="text"
            [(ngModel)]="docTypeData.documentTypeCodeForIdGeneration">
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <!-- Is Expiry Applicable? -->
          <div><label for="email">{{dynamicLabel['IS_EXPIRY_APPLICABLE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.isExpiryApplicable1">
            <span class="active-inActive-container" *ngIf="docTypeData.isExpiryApplicable1==true"
              [ngStyle]="docTypeData.isExpiryApplicable1==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="docTypeData.isExpiryApplicable1==false"
              [ngStyle]="docTypeData.isExpiryApplicable1==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" *ngIf="docTypeData.isExpiryApplicable1">
          <div>
            <label for="expiryInInput">{{dynamicLabel['EXPIRY_IN']}}
              <span *ngIf="docTypeData.isExpiryApplicable1" class="mandatory-symbol">*</span>
            </label>
          </div>
          <input id="expiryInInput" class="input-filed-continers" type="number" [(ngModel)]="docTypeData.expiryIn">

          <span id="expiryin-required-msg">
            Please enter expiry days
          </span>
        </div>

        <div class="col-md-3" *ngIf="docTypeData.isExpiryApplicable1"
          [ngStyle]="docTypeData.amendmentEnabled && docTypeData.extentionEnabled ? {'margin-top':'1%'}: {}">
          <div>
            <label for="expiryUnitSelect">{{dynamicLabel['EXPIRY_IN_UNIT']}}</label>
            <span *ngIf="docTypeData.isExpiryApplicable1" class="mandatory-symbol">*</span>
          </div>

          <mat-select id="expiryUnitSelect" matInput placeholder="Select"
            [ngClass]="{'odd-item-mat-select': oddExpiryInUnit == selectedexpiryInUnit}"
            [(ngModel)]="selectedexpiryInUnit" (closed)="expirysearchTxt=''"
            (keydown.enter)="focusmethod('expiryfocusSearch')" (click)="focusmethod('expiryfocusSearch')">
            <input type="search" id="expiryfocusSearch" class="dropdownsearchstyle" [(ngModel)]="expirysearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of expiryInUnitDropdown | assessmentSearch :expirysearchTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

          <span id="expiryUnit-required-msg">
            Please select expiry in unit
          </span>
        </div>
        <div class="col-md-2" [hidden]="this.modulevalue!='DOCS'">
          <!-- Override Effective Date ? -->
          <div><label for="email">{{dynamicLabel['OVERRIDE_EFFECTIVE_DATE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.overrideEffectiveDate">
            <span class="active-inActive-container" *ngIf="docTypeData.overrideEffectiveDate"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.overrideEffectiveDate" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-2" [hidden]="this.modulevalue!='DOCS'">
          <!-- Override Expiry Date ? -->
          <div><label for="email">{{dynamicLabel['OVERRIDE_EXPIRY_DATE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.overrideExpiryDate">
            <span class="active-inActive-container" *ngIf="docTypeData.overrideExpiryDate"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.overrideExpiryDate" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-2" [hidden]="this.modulevalue!='DOCS' && this.modulevalue!='TRN'">
          <!-- Is Blindable ? -->
          <div><label for="email">{{dynamicLabel['IS_BLINDABLE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.isBlindable">
            <span class="active-inActive-container" *ngIf="docTypeData.isBlindable" style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.isBlindable" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <div><label for="email">{{dynamicLabel['TEMPLATE_NAME']}}</label></div>
          <mat-select matInput placeholder="Select" [ngClass]="{'odd-item-mat-select': oddTemplate == selectedTemplate}"
            [(ngModel)]="selectedTemplate" (closed)="templatesearchTxt=''" (click)="focusmethod('templatefocusSearch')"
            (keydown.enter)="focusmethod('templatefocusSearch')">
            <input type="search" id="templatefocusSearch" class="dropdownsearchstyle" [(ngModel)]="templatesearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of TemplateDropdown | assessmentSearch :templatesearchTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <label for="email">{{dynamicLabel['DOWNLOAD_TEMPLATE_NAME']}}</label>
          <mat-select class="input-filed-continers" placeholder="Select" [(ngModel)]="selectedDownloadTemplate">
            <mat-option [value]="null" class="unselectStyle">
              Un-select
            </mat-option>
            <mat-option *ngFor="let item of downloadTemplateList" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-3" [hidden]="this.modulevalue!='DOCS'">
          <!-- Expiry In -->
          <div><label for="email">Print Additional Page At Download?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="docTypeData.printAdditionalPageAtDownload1"
            (change)="toggle($event)">
            <span class="active-inActive-container" *ngIf="docTypeData.printAdditionalPageAtDownload1"
              style="color: green;">Yes</span>
            <span *ngIf="!docTypeData.printAdditionalPageAtDownload1" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" *ngIf="docTypeData.printAdditionalPageAtDownload1">
          <!-- Expiry In -->
          <div><label for="email">Additional Page Name</label><span class="mandatory-symbol">*</span></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="docTypeData.additionalPageName">
        </div>

        <div class="col-md-3" *ngIf="docTypeData.printAdditionalPageAtDownload1">
          <div><label for="email">Additional Page Content</label><span class="mandatory-symbol">*</span></div>
          <span *ngIf="!clearedPageContent && pageContent">
            <span>{{docTypeData.documentTypeName}}.pdf</span>
            <i class="fa fa-close" (click)="removePageContent()" (keydown.enter)="removePageContent()"
              style="color: red;margin-left: 8px;font-size: 18px;"></i>
          </span>
          <input *ngIf="clearedPageContent || !pageContent" type="file" class="file-input"
            (change)="onFileSelected($event)" accept="pdf" #fileUpload>
        </div>
        <div class="col-md-3" *ngIf="docTypeData.printAdditionalPageAtDownload1">
          <!-- Template -->
          <div><label for="email">Additional Page Print Position</label><span class="mandatory-symbol">*</span></div>

          <mat-select matInput placeholder="Select" [(ngModel)]="docTypeData.additionalPagePrintPosition"
            (closed)="additionalPagePrintsearchTxt=''" (click)="focusmethod('additionalPagePrintfocusSearch')"
            (keydown.enter)="focusmethod('additionalPagePrintfocusSearch')">
            <input type="search" id="additionalPagePrintfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="additionalPagePrintsearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option
              *ngFor="let item of additionalPagePrintPositionDropdown | assessmentSearch :additionalPagePrintsearchTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <!-- Expiry In -->
          <div><label for="email">Name At Reports</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="docTypeData.documentTypeNameAtReports">
        </div>
        <div class="col-md-3">
          <!-- Expiry In -->
          <div><label for="email">Code At Reports</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="docTypeData.documentTypeCodeAtReports">
        </div>
        <div class="col-md-3">
          <!-- Withdraw List Of Stages -->
          <div><label for="email">Report Header Template</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="reportHeaderTemplateId"
            (closed)="reportHeaderTemplateSearchText=''" (click)="focusSearch('reportHeaderTemplatefocus')"
            (keydown.enter)="focusSearch('reportHeaderTemplatefocus')">
            <input type="search" id="reportHeaderTemplatefocus" class="dropdownsearchstyle"
              [(ngModel)]="reportHeaderTemplateSearchText" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option
              *ngFor="let item of dropdownForHeaderReportTemplate | assessmentSearch :reportHeaderTemplateSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6" *ngIf="visibleEditButton">
          <!-- Reason for Update -->
          <div><label for="email">{{dynamicLabel['UPDATE_REASON']}}</label><span style="color: red;">*</span></div>
          <textarea id="updateReason" type="text" class="input-filed-textarea" rows="3" cols="50"
            [(ngModel)]="docTypeData.updateReason"></textarea>
          <span id="updateReason-required-msg">Please provide the reason for update</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(docTypeData)" (keydown.enter)="addAndEditFunction(docTypeData)"
      *ngIf="!visibleEditButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(docTypeData)" (keydown.enter)="addAndEditFunction(docTypeData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Delete Document Type</label>
    <label for="app-name" class="popupAppTitle">ONE-<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">Reason for Delete</label><span style="color: red;">*</span></div>
        <textarea id="deleteReason" type="text" class="input-filed-textarea" rows="4" cols="50"
          [(ngModel)]="deleteReason"></textarea>
        <span id="deleteReason-required-msg">Please provide the reason for delete</span>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="deleteFunction()">
        <i class="fas fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #notePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelNote()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Reference Tags</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        &lt;DOCUMENT_NO&gt;<br>
        &lt;DOCUMENT_VERSION&gt;<br>
        &lt;DOCUMENT_TYPE_CODE&gt;<br>
        &lt;DOCUMENT_TYPE_NAME&gt;<br>
        &lt;PARENT_DOCUMENT_NO&gt;<br>
        &lt;PARENT_DOCUMENT_VERSION&gt;<br>
        &lt;PARENT_DOCUMENT_TYPE_CODE&gt;<br>
        &lt;PARENT_DOCUMENT_TYPE_NAME&gt;<br>
        &lt;ISSUANCE_TYPE&gt;<br>
        &lt;DOCUMENT_NAME&gt;<br>
        &lt;EFFECTIVE_DATE&gt;<br>
        &lt;EXPIRY_DATE&gt;<br>
        &lt;CURRENT_DATE&gt;<br>
        &lt;USER_NAME&gt;<br>
        &lt;USER_FULLNAME&gt;<br>
        &lt;ISSUED_TO&gt;<br>
        &lt;PRINTS_TAKEN&gt;<br>
        &lt;ISSUANCE_REASON&gt;<br>
        &lt;TEMPLATE_NAME&gt;<br>
        &lt;STATUS&gt;
      </div>
    </div>
  </div>
</ng-template>
<ng-template #copyPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelCopyFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Copy Document Type</label>
    <label for="app-name" class="popupAppTitle">ONE-<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-6">
        <div><label for="email">Document Type Name</label><span class="mandatory-symbol">*</span></div>
        <input id="documentTypeNameForCopy" class="input-filed-continers" type="text"
          [(ngModel)]="copyDocumentTypeData.documentTypeName">
        <span id="documentTypeNameForCopy-required-msg">Please enter the Document Type Name</span>
      </div>
      <div class="col-md-6">
        <div><label for="email">Document Type Code</label><span class="mandatory-symbol">*</span></div>
        <input id="documentTypeCodeForCopy" class="input-filed-continers" type="text"
          [(ngModel)]="copyDocumentTypeData.documentTypeCode" (keydown)="validateCodeFields($event)"
          (input)="sanitizeCopyCode($event)" (paste)="onPasteSanitizeCopyCode($event)">
        <span id="documentTypeCodeForCopy-required-msg">Please enter the Document Type Code</span>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="copyFunction()">
        <i class="fa fa-copy"></i> Copy
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelCopyFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>